import { ChangeDetectorRef,OnInit, Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToWords } from 'to-words';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-booktworecipt',
  templateUrl: './booktworecipt.component.html',
  styleUrl: './booktworecipt.component.scss'
})
export class BooktworeciptComponent {


  receiptdata: any;
    totalinWords: String;
    toWords: any;
    receiptnumber: any
    recpt_no: any;
    data2: any;
  
    constructor(private dialogRef: MatDialogRef<BooktworeciptComponent>,
      @Inject(MAT_DIALOG_DATA) public data1: any,
      private service: DigisubservicesService,
      private cdr: ChangeDetectorRef, private fb: FormBuilder
    ) { }
  
    ngOnInit(): void {
      debugger
  
  
      this.receiptdata = this.data1['receiptdata'];
      debugger;
  
      this.recpt_no = this.receiptdata.map(item => item.receipt_no);
  
      console.log(this.recpt_no, "recpt number");
      
      this.service.getBookRcptwise(this.recpt_no).subscribe((res) => {
        
        this.data2 = res;
      console.log(this.data2)
  
      });
  
     
  
    }

    getLabel(data: any): string {
  const val = (data.bill_no || data.order_no || '').toString().trim().toUpperCase();

  if (val.startsWith('V')) {
    return 'बिल नंबर :';
  }

  if (val.startsWith('B')) {
    return 'ऑर्डर नंबर :';
  }

  return 'नंबर :';
}

getValue(data: any): string {
  return (data.bill_no || data.order_no || '').toString().trim();
}

  
  
    numbertotext(rcv_amt:any){
      this.toWords = new ToWords();
      this.totalinWords = this.toWords.convert(rcv_amt, {
        currency: true,
      });
      console.log(this.totalinWords,"numbertotext")
      return this.totalinWords
    }
  
    print(): void {
      window.print();
    }
}
